import { render, staticRenderFns } from "./ComTable.vue?vue&type=template&id=364ca182&scoped=true&"
import script from "./ComTable.vue?vue&type=script&lang=js&"
export * from "./ComTable.vue?vue&type=script&lang=js&"
import style0 from "./ComTable.vue?vue&type=style&index=0&id=364ca182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364ca182",
  null
  
)

export default component.exports